<template>
  <div class="mt-4">
    <div class="inline-block w-1/3 mb-4">
      <label v-if="!isReadOnly">Ajouter un utilisateur</label>
      <v-select
      v-if="!isReadOnly"
      :options="internsList"
      :filterable="true"
      label="name"
      placeholder="Rechercher un utilisateur..."
      v-model="selectedUser"
      @input="onUserSelect($event)"
      />
    </div>

    <div v-if="!isReadOnly" class="inline-block w-2/3 text-right px-4">
      <button @click="onImportUserClick" type="button" class="twn-button block whitespace-no-wrap overflow-hidden text-xs mb-2 ml-auto">Importer des utilisateurs</button>
      <span>{{ this.promotion.users.length }}</span>
      <span> utilisateurs</span>
    </div>

    <div class="border-line-left border rounded p-4">
      <table class="group-interns w-full">
        <tr>
          <th>Nom</th>
          <th>Prénom</th>
          <th>Email</th>
          <th>Statut</th>
          <th>Progression</th>
          <th v-if="!isReadOnly"></th>
        </tr>

        <tr
          v-for="intern in promotion.users"
          :key="intern.id"
          class="cursor-pointer"
          @click="onEditInternClick(intern)"
        >
          <template v-if="interns[intern.id]">
            <td>{{interns[intern.id].first_name}}</td>
            <td>{{interns[intern.id].name}}</td>
            <td>{{interns[intern.id].email}}</td>
            <td>{{interns[intern.id].state}}</td>
            <td>{{interns[intern.id].progress}}</td>
            <td
              v-if="!isReadOnly"
              class="flex justify-center text-xl font-bold items-center cursor-pointer col-span-1"
              @click.stop="onRemoveInternClick(intern)"
            >
              <div class="border border-gray-light rounded-full text-center w-8 h-8">-</div>
            </td>
          </template>
        </tr>
      </table>
    </div>

    <UserImportModal v-model="isImportModalOpen" :defaultGroup="promotion.id" />
  </div>
</template>

<script>

import { mapState } from 'vuex'

import userFieldsValues from "@/constants/userFieldsValues"

import { getUserProgressData, getUserState, getUserGroupState } from "@/utils/userUtils"

import UserImportModal from '@/components/common/user/UserImportModal'

export default {
  props: {
    promotion: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UserImportModal
  },
  data() {
    return {
      isImportModalOpen: false,
      selectedUser: null,
      level1: null,
      level2: null,
    }
  },
  async mounted() {
    this.level1 = await this.$store.dispatch('Course/GetCourseByType', 'mission')
    this.level2 = await this.$store.dispatch('Course/GetCourseByType', 'investigation')
  },
  computed: {
    ...mapState('Utils', ['userList']),
    internsList() {
      if (!this.userList)
        return []

      return this.userList.filter((user) => {
        return (!user.groups || user.groups.length <= 0) && !this.promotion.users.some((intern) => (user.id == intern.id))
      }).map((user) => {
        return {
          id: user.id,
          name: [user.first_name, user.name].filter(str => str || false).join(' ') + ' - ' + user.email,
        }
      })
    },
    interns() {
      if (!this.level1 || !this.level2 || !this.promotion.users)
        return {}

      return this.promotion.users.reduce((dict, user) => {
        // Set user progress lable
        const progressData = getUserProgressData(user.logs, this.level1.id, this.level2.id)

        if (progressData.hasDoneLevel1 && progressData.hasDoneLevel2) {
          user.progress = 'Formation terminée'
        } else if (progressData.hasDoneLevel1) {
          user.progress = `Niveau 2 : ${progressData.level2Progress}/${this.level2.modules_aggregate.aggregate.count}`
        } else if (progressData.level1Progress > 0) {
          user.progress = `Niveau 1 : ${progressData.level1Progress}/${this.level1.modules_aggregate.aggregate.count}`
        } else {
          user.progress = '-'
        }

        // Set user state label
        user.state = userFieldsValues.stateMap[getUserState(user)]?.label || '-'

        // Add user group state label if needed
        const groupState = getUserGroupState(user)

        if (groupState === 'disabled') {
          user.state += ' - Promotion suspendue'
        } else if (groupState === 'inactive') {
          user.state += ' - Promotion inactive'
        }

        dict[user.id] = user

        return dict
      }, {})
    },
  },
  methods: {
    onUserSelect(intern) {
      this.$emit('add-intern', intern)

      this.$nextTick(() => this.selectedUser = null)
    },
    onEditInternClick(intern) {
      const routeData = this.$router.resolve({
        name: 'user-edit',
        params: {
          itemID: intern.id,
        },
      })
      window.open(routeData.href, '_blank');
    },
    onRemoveInternClick(intern) {
      this.$emit('remove-intern', intern)
    },
    onImportUserClick() {
      this.isImportModalOpen = true
    }
  },
};
</script>

<style lang="scss">
  .group-interns {
    @apply border-separate;

    tr {
      &:hover td {
        @apply border-gray-lighter;
      }
    }

    td {
      @apply py-1 border-t-1 border-b-1 border-white;
    }
  }
</style>